import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { Company } from '_lib/api/apiTypes.shim';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';

import {
  CompanyConfigBillingForm,
  companyConfigBillingFormValues,
  CompanyConfigBillingFormValues
} from '../../CompanyFormItems/CompanyConfigBillingForm/CompanyConfigBillingForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';

type CompanyConfigBillingProps = {
  company: Company;
  authUser: AuthUser;
  tabChangeObj: TabChangeObj;
};

export const CompanyConfigBilling = (props: CompanyConfigBillingProps) => {
  const { company, authUser, tabChangeObj } = props;
  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyConfigBillingFormValues,
    tabChangeObj,
    snackMessage: 'Company billing saved'
  });

  return (
    <FormWrapper
      isFetchingOrPending={isPending}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      <CompanyConfigBillingForm
        companyConfigBillingFormContext={
          // TODO: there is a bug with the DTO typing, similar to the 'address' fields, where we are missing the billing fields
          companyUpdateFormContext as unknown as UseFormReturn<CompanyConfigBillingFormValues>
        }
        disabled={!company?.isActive}
      />
    </FormWrapper>
  );
};
